// extracted by mini-css-extract-plugin
export default {"modal":"ModalCookies_modal__gdDM6","bio":"ModalCookies_bio__M4+6L","buttons":"ModalCookies_buttons__L8fl6"};